
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { apiShopMoneyData, apiShopLists } from "@/api/shop";
import SearchBtns from "@/components/search-btns.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import ExportData from "@/components/export-data/index.vue";

@Component({
  components: {
    LsPagination,
    DatePicker,
    elImageViewer,
    SearchBtns,
    ExportData,
  },
})
export default class ShopMoneyList extends Vue {
  // 界面表格数据
  pager: any = new RequestPaging();

  apiShopMoneyData = apiShopMoneyData;
  searchObj: any = {
    sid: "",
    date: "",
  };
  money_type_list: any[] = [];
  type_list: any[] = [];
  loading = false;
  shopList: any[] = [];
  activeMoneyRow: any = null;
  moneyPopoverVisible = false;
  moneyPopoverPosition = {
    left: 0,
    top: 0,
  };
  moneyPopoverHideTimer: any = null;
  moneyPopoverGroups: any[] = [
    {
      title: "出账账本",
      key: "dec_money_list",
      items: [
        { label: "商户名称", prop: "name" },
        { label: "支出金额", prop: "res_money" },
      ],
    },
    {
      title: "收入账本",
      key: "inc_money_list",
      items: [
        { label: "商户名称", prop: "name" },
        { label: "收入金额", prop: "res_money" },
      ],
    },
  ];

  get moneyPopoverStyle() {
    return {
      left: `${this.moneyPopoverPosition.left}px`,
      top: `${this.moneyPopoverPosition.top}px`,
    };
  }

  showMoneyRowPopover(
    row: any,
    column: any,
    cell: HTMLElement,
    event: MouseEvent,
  ) {
    if (this.moneyPopoverHideTimer) {
      clearTimeout(this.moneyPopoverHideTimer);
      this.moneyPopoverHideTimer = null;
    }
    this.activeMoneyRow = row;
    this.moneyPopoverVisible = true;
    this.setMoneyPopoverPosition(event);
  }

  scheduleMoneyRowPopoverHide() {
    if (this.moneyPopoverHideTimer) {
      clearTimeout(this.moneyPopoverHideTimer);
    }
    this.moneyPopoverHideTimer = window.setTimeout(() => {
      this.hideMoneyRowPopover();
    }, 80);
  }

  hideMoneyRowPopover() {
    if (this.moneyPopoverHideTimer) {
      clearTimeout(this.moneyPopoverHideTimer);
      this.moneyPopoverHideTimer = null;
    }
    this.moneyPopoverVisible = false;
    this.activeMoneyRow = null;
  }

  moveMoneyRowPopover(event: MouseEvent) {
    if (!this.moneyPopoverVisible) {
      return;
    }
    this.setMoneyPopoverPosition(event);
  }

  setMoneyPopoverPosition(event: MouseEvent) {
    const gap = 14;
    const popoverWidth = 520;
    const popoverHeight = 420;
    let left = event.clientX + gap;
    let top = event.clientY + gap;

    if (left + popoverWidth > window.innerWidth) {
      left = Math.max(8, event.clientX - popoverWidth - gap);
    }
    if (top + popoverHeight > window.innerHeight) {
      top = Math.max(8, window.innerHeight - popoverHeight - gap);
    }

    this.moneyPopoverPosition = {
      left,
      top,
    };
  }

  getMoneyPopoverValue(row: any, prop: string) {
    const value = row ? row[prop] : "";
    return value === null || value === undefined || value === "" ? "-" : value;
  }

  handleSearch() {
    this.pager.page = 1;
    this.getList();
  }
  getList() {
    this.loading = true; // 开始加载状态
    this.pager
      .request({
        callback: this.apiShopMoneyData,
        params: this.searchObj, // 传递搜索参数
      })
      .then((res: any) => {
        this.loading = false; // 请求完成，停止加载状态
      })
      .catch((error: any) => {
        console.error("获取订单列表失败:", error);
      });
  }

  async getShopList() {
    try {
      let res = await apiShopLists({ page_size: 9999 });
      this.shopList = res.lists;
    } catch (error) {}
  }
  async mounted() {
    this.searchObj.date = new Date().toLocaleDateString().split("/").join("-");
    await this.getShopList();
    this.getList();
  }
}
